import {IconButton, Slot, Text, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {Image} from '@yandex-delivery/blocks/image'
import React, {memo} from 'react'

import {tagToUrl} from '../../../../lib/tagToUrl'
import * as classes from './Header.classes'

const CROSS_SLUG = 'delivery_form_cross_fill'

type HeaderProps = {
  onClose?: VoidFunction
  title: string
}

export const Header = memo(
  ({onClose, title}: HeaderProps): React.ReactElement => (
    <Paper className={classes.header} padding="none">
      <Slot size="l">
        <Text>
          <Typography thickness="bold" variant="title4">
            {title}
          </Typography>
        </Text>
        {onClose && (
          <IconButton onClick={onClose} variant="ghost">
            <Image height={24} src={tagToUrl(CROSS_SLUG)} />
          </IconButton>
        )}
      </Slot>
    </Paper>
  ),
)
